












































































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { AutenticacaoRemotaUseCase, FindPerfilUseCase, FindUsuarioUseCase, RegistroDeLiberacaoUseCase, LoginUseCase } from '@/usecases'
import { TokenJwt, Credenciais, Desconto, Perfil, ItemDaVenda, StatusDaAutenticacaoRemota, TipoDaAutenticacaoRemota } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TipoDeRegraDePermissao } from '@/models/RegraDeNegocio'
import { perfilTemRegraDeNegocio } from '@/shareds/permissoes-shareds'
import { VendaModule } from '@/store/vuex/venda/VendaStore'

function gerarCredenciais(): Credenciais {
	return {
		login: '',
		senha: '',
	}
}

@Component
export default class DialogoDeAutenticacao extends Vue {
	@Ref() formDialogoAutenticacao!: HTMLFormElement
	@Ref() campoDeLogin!: HTMLInputElement
	@Ref() formDescricaoRemoto!: any

	obrigatorio = obrigatorio

	carregando = false
	mostra = false
	mostraErro = false
	regra: TipoDeRegraDePermissao | null = null
	errorMessage = ''
	persistent = false
	validar = true
	autenticacaoPadrao = true
	desconto: Desconto | null = null
	itemDaVenda: ItemDaVenda | null = null
	solicitacaoRemotaId: string | null = null
	identificadorAuthRemotaId: string | null = null
	mostraModalRemoto = false
	carregandoRemoto = false
	statusRemoto: StatusDaAutenticacaoRemota | 'PENDENTE' = 'PENDENTE'
	cooldownSegundos = 0
	cooldownTimer: number | null = null
	ultimoCheckEmMs: number | null = null
	mostraModalDescricaoRemoto = false
	descricaoRemota = ''
	apenasAutenticacaoRemota = false
	motivoPadraoRemoto = ''

	autenticacaoRemotaUseCase = new AutenticacaoRemotaUseCase()
	registroDeLiberacaoUseCase = new RegistroDeLiberacaoUseCase()


	credenciais = gerarCredenciais()
	resolveDialogo: ((value: { autenticado: boolean; usuarioId?: string }) => void) | null = null

	resolverDialogoPendente(resultado: { autenticado: boolean; usuarioId?: string }) {
		const resolve = this.resolveDialogo
		if (!resolve) return
		this.resolveDialogo = null
		resolve(resultado)
	}

	get autenticacaoGeral() {
		return UserLoginStore.autenticando
	}

	async mostrar(
		lojaId?: string | undefined,
		regra?: TipoDeRegraDePermissao,
		desconto?: Desconto,
		item?: ItemDaVenda,
		persistent = false,
		validar = true,
		autenticacaoPadrao?: boolean,
		opcoes?: { apenasAutenticacaoRemota?: boolean; motivoPadrao?: string; regraParaAutoLiberacao?: TipoDeRegraDePermissao },
	): Promise<{ autenticado: boolean; usuarioId?: string }> {
		// Essa instância é compartilhada globalmente (VendaModule.dialogoDeAutenticacao). Se já existe
		// uma autenticação pendente (ex.: um watcher reagindo à mesma troca de venda/cliente dispara
		// uma segunda chamada concorrente), resolve a anterior como não autenticada antes de seguir —
		// senão essa promise anterior nunca resolveria, travando quem estava esperando ela pra sempre.
		this.resolverDialogoPendente({ autenticado: false })

		this.desconto = desconto || null
		this.itemDaVenda = item || null
		this.apenasAutenticacaoRemota = opcoes?.apenasAutenticacaoRemota ?? false
		this.motivoPadraoRemoto = opcoes?.motivoPadrao ?? ''

		const temPermissaoDeAutoLiberacao =
			(!!regra && UserLoginStore.permiteRegraDeNegocio(regra)) ||
			(!!opcoes?.regraParaAutoLiberacao && UserLoginStore.permiteRegraDeNegocio(opcoes.regraParaAutoLiberacao))
		if (!this.apenasAutenticacaoRemota && temPermissaoDeAutoLiberacao && !desconto) {
			return {
				autenticado: true,
				usuarioId: this.credenciais.usuarioIdLiberacaoVendaSemEstoque,
			}
		}

		this.mostra = true
		this.regra = regra || null
		this.persistent = persistent
		this.credenciais.lojaId = lojaId
		this.validar = validar

		this.autenticacaoPadrao = autenticacaoPadrao ?? true

		const promise = new Promise<{ autenticado: boolean; usuarioId?: string }>(resolve => {
			this.resolveDialogo = resolve
		})

		if (this.apenasAutenticacaoRemota) {
			if (!this.permiteAutenticacaoRemotaDoPerfil || !this.regra) {
				AlertModule.setError('Esta liberação só pode ser feita por autenticação remota, e o usuário logado não tem permissão para solicitar. Peça para um usuário autorizado solicitar a liberação.')
				this.mostra = false
				this.resolverDialogoPendente({ autenticado: false })
				return promise
			}

			await this.solicitarAutenticacaoRemota(opcoes?.motivoPadrao)
			return promise
		}

		setTimeout(() => {
			this.campoDeLogin.focus()
			setTimeout(() => {
				this.formDialogoAutenticacao.resetValidation()
			})
		})

		return promise
	}

	@Watch('mostra')
	async onChangeMostra(mostra: boolean) {
		if (!mostra) {
			await this.cancelarSePendente()
			// Só resolve se ainda não foi resolvido (evita resolução dupla quando cancelandoAcao é chamado)
			this.resolverDialogoPendente({ autenticado: false })
			return
		}
		this.credenciais = {
			...this.credenciais,
			login: '',
			senha: '',
		}
	}

	cancelandoAcao() {
		this.resolverDialogoPendente({ autenticado: false })
		this.mostra = false
	}

	async autenticar(): Promise<void> {
		if (!this.formDialogoAutenticacao.validate()) return
		try {
			this.carregando = true
			const tokenJwt: TokenJwt = await new LoginUseCase().signIn(this.credenciais)
			if (!tokenJwt) throw new Error('Usuário ou senha inválidos')
			if (UserLoginStore.autenticando) await this.validarUsuarioLogado(tokenJwt)
			if (this.regra) await this.validarPermissaoDoLogin(tokenJwt, this.regra)
			this.registrarLiberacao()
			this.resolverDialogoPendente({ autenticado: true, usuarioId: this.credenciais.usuarioId })
			this.mostra = false
			this.mostraErro = false
		} catch (error: any) {

			if(UserLoginStore.autenticando) {
				this.errorMessage = error.message;
				this.mostraErro = true
			} else AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	registrarLiberacao() {
		// Registra, de forma assíncrona e não bloqueante, a liberação inline concedida por um
		// supervisor (autenticação com credenciais de outro usuário). Só registra quando há uma
		// regra de permissão associada — o caminho remoto e o de "operador já tem a regra" não
		// passam por aqui. Falhas não interrompem a ação do operador (fire-and-forget).
		const regra = this.regra
		const usuarioLiberacaoId = this.credenciais.usuarioId
		if (!regra || !usuarioLiberacaoId) return

		this.registroDeLiberacaoUseCase
			.criar({
				regraDePermissao: regra,
				usuarioLiberacaoId,
				valor: this.desconto?.valor,
				isPercentual: this.desconto?.isPercentual,
				vendaId: VendaModule.vendaAtual?.id,
			})
			.catch(error => console.error('Falha ao registrar liberação', error))
	}

	async validarUsuarioLogado(tokenJwt: TokenJwt) {
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub

		if (UserLoginStore.usuario?.id && idUsuario === UserLoginStore.usuario.id) {
			UserLoginStore.setToken(tokenJwt.token)
			return
		}

		const usuarioLogado = await new FindUsuarioUseCase().usuarioLogado()
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		if (usuario.id !== usuarioLogado.id) throw new Error('Credenciais diferem do usuário já logado.')
	}

	async validarPermissaoDoLogin(tokenJwt: TokenJwt, regra: TipoDeRegraDePermissao) {
		const payload = JSON.parse(atob(tokenJwt.token.split('.')[1]))
		const idUsuario = payload.sub
		const usuario = await new FindUsuarioUseCase().findById(idUsuario)
		if (!usuario) throw new Error('Usuário não encontrado')
		this.credenciais.usuarioId = usuario.id
		const perfil = await new FindPerfilUseCase().findById(usuario.perfil.id) || null

		if (!perfilTemRegraDeNegocio(perfil, regra)) throw new Error(`Usuário não tem permissão (${this.regra})`)

		this.itemDaVenda 
			? this.validarValorDescontoItemDaVenda(perfil, this.itemDaVenda)
			: this.validarValorDescontoCapaDaVenda(perfil)
	}

	validarValorDescontoItemDaVenda(perfil: Perfil, item: ItemDaVenda) {
		const venda = VendaModule.vendaAtual
		if (venda && this.desconto && this.desconto.valor > 0) {
			if(perfil.permissoes.includes('pode-conceder-desconto-por-item')) {
				if(item.possuiDescontoPorTabela) {
					const porcentagemDeDescontoDoItem = this.desconto.isPercentual
						? this.desconto.valor
						: (this.desconto.valor / item.preco) *100
					
					const percentualDeDescontoMaximo = Math.max(item.percentualDescontoTabelaPreco, perfil.percentualMaximoDescontoPorItem)

					if(porcentagemDeDescontoDoItem > percentualDeDescontoMaximo && venda.pagamentos.length < 1) {
						throw new Error('O usuário informado não possui limite de desconto suficiente para liberar este desconto. Informe um usuário autorizado.')
					}
				} else {
					const valorDeDescontoDoItem = item.possuiDescontoPorTabela ? 0 : this.desconto.valor
					const porcentagemDeDescontoDoItem = this.desconto.isPercentual
						? valorDeDescontoDoItem
						: (this.desconto.valor / item.preco) *100

					if(porcentagemDeDescontoDoItem > perfil.percentualMaximoDescontoPorItem && venda.pagamentos.length < 1) {
						throw new Error('O usuário informado não possui limite de desconto suficiente para liberar este desconto. Informe um usuário autorizado.')
					}
				}
			} else {
				throw new Error('Usuário não tem permissão para conceder desconto por item')
			}
		}
	}

	validarValorDescontoCapaDaVenda(perfil: Perfil) {
		const venda = VendaModule.vendaAtual
		if (venda && this.desconto && this.desconto.valor > 0) {
			let valorTotalDeDescontoDosItens = 0;
			let valorBrutoDaVenda = 0;

			for(let i=0; venda.itens.length > i; i++) {
				const item = venda.itens[i]
				
				if(!item.possuiDescontoPorTabela && item.isCompra && this.desconto.valor > 0) {
					if(item.desconto.isPercentual) {
						const retiraValorDaPorcentagem = item.preco * (item.desconto.valor / 100);
						valorTotalDeDescontoDosItens = valorTotalDeDescontoDosItens + retiraValorDaPorcentagem;
					} else {
						valorTotalDeDescontoDosItens = valorTotalDeDescontoDosItens + item.desconto.valor;
					}
				}
				if(item.possuiDescontoPorTabela) {
					const descontoDaTabelaDePreco = (venda.itens[i].preco * (venda.itens[i].desconto.valor / 100))
					valorBrutoDaVenda = valorBrutoDaVenda + (venda.itens[i].preco - descontoDaTabelaDePreco)
				} else {
					valorBrutoDaVenda = valorBrutoDaVenda + (venda.itens[i].preco)
				}
			}

			const porcentagemDeDescontoDaCapa = this.desconto.isPercentual
				? this.desconto.valor
				: (this.desconto.valor / valorBrutoDaVenda) *100

			if (porcentagemDeDescontoDaCapa > perfil.percentualMaximoDesconto && venda.pagamentos.length < 1) {
				throw new Error('O usuário informado não possui limite de desconto suficiente para liberar este desconto. Informe um usuário autorizado.')
			}
		}
	}

	get permiteAutenticacaoRemotaDoPerfil() {
		return UserLoginStore.permiteRegraDeNegocio('permite-solicitar-autenticacao-remota')
	}

	async solicitarAutenticacaoRemota(motivoPadrao?: string) {
		if (!this.regra) return

		this.descricaoRemota = motivoPadrao ?? this.motivoPadraoRemoto ?? ''
		this.mostraModalDescricaoRemoto = true

		this.$nextTick(() => {
			if (this.formDescricaoRemoto?.resetValidation) {
				this.formDescricaoRemoto.resetValidation()
			}
		})
	}

	async enviarSolicitacaoRemota() {
		if (!this.regra) return
		try {
			this.carregandoRemoto = true

			const tipo = this.mapearTipoDaRegra(this.regra)
			const venda = VendaModule.vendaAtual
			const desconto = this.desconto

			let percentualDesconto = 0

			if (desconto && desconto.valor > 0) {
				if (this.itemDaVenda) {
					percentualDesconto = this.calcularPercentualDescontoDoItem(desconto, this.itemDaVenda)
				} else if (venda) {
					percentualDesconto = this.calcularPercentualDescontoDaCapa(desconto, venda)
				}
			}

			percentualDesconto = Number(percentualDesconto.toFixed(2))

			const payload = {
				tipo, 
				regraDePermissao: this.regra,
				valorDesconto: percentualDesconto,
				descricao: this.descricaoRemota,
			}

			const criada = await this.autenticacaoRemotaUseCase.criarAutenticacaoRemota(payload)
			this.solicitacaoRemotaId = criada.id
			this.statusRemoto = criada.status ?? 'PENDENTE'
			this.identificadorAuthRemotaId = criada.identificador

			this.mostraModalRemoto = true
			this.mostraErro = false 
		} catch (e: any) {
			AlertModule.setError('Não foi possível solicitar autenticação remota')
		} finally {
			this.carregandoRemoto = false
			this.cancelarDescricaoRemota()
		}
	}

	async verificarStatusRemoto() {
		if (!this.solicitacaoRemotaId) return
		if (this.cooldownSegundos > 0) return
		this.iniciarCooldown(15)

		try {
			this.carregandoRemoto = true
			const auth = await this.autenticacaoRemotaUseCase.findById(this.solicitacaoRemotaId)

			this.statusRemoto = auth.status

			if (auth.status === 'Liberado') {
				this.limparCooldown()
				this.resolverDialogoPendente({ autenticado: true })

				this.mostraModalRemoto = false
				this.mostra = false
				return
			}

			if (auth.status === 'Negado' || auth.status === 'Cancelado') {
				this.limparCooldown()
				this.errorMessage = auth.status === 'Negado'
					? 'Solicitação negada.'
					: 'Solicitação cancelada.'
				AlertModule.setError(this.errorMessage)
				this.mostraModalRemoto = false
				
			}
		} catch (e: any) {
			AlertModule.setError('Não foi possível verificar o status')
		} finally {
			this.carregandoRemoto = false
		}
	}

	async cancelarSolicitacaoRemota() {
		if (!this.solicitacaoRemotaId) return
		await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(this.solicitacaoRemotaId, 'Cancelado')
		this.limparCooldown()
		AlertModule.setSuccess("Solicitação remota cancelada!")
		this.mostraModalRemoto = false
		this.mostra = false
	}

	mapearTipoDaRegra(regra: TipoDeRegraDePermissao): TipoDaAutenticacaoRemota {
		switch (regra) {
			case 'pode-liberar-venda-fora-do-estado':
				return 'Fiscal'
			default:
				return 'Financeiro'
		}
	}

	@Watch('mostraModalRemoto')
	async onChangeMostraModalRemoto(aberto: boolean) {
		if (!aberto) {
			await this.cancelarSePendente()
		}
	}

	private async cancelarSePendente() {
		if (!this.solicitacaoRemotaId) return
		if (this.statusRemoto !== 'Pendente') return

		try {
			await this.autenticacaoRemotaUseCase.atualizarStatusDaAutenticacaoRemota(this.solicitacaoRemotaId, 'Cancelado')
		} catch(error: any) {
			AlertModule.setError("Não foi possível atualizar o status da autenticação remota.")
		} finally {
			this.solicitacaoRemotaId = null
			this.statusRemoto = 'Pendente'
			this.limparCooldown()
		}
	}

	async beforeDestroy() {
		await this.cancelarSePendente()
	}

	iniciarCooldown(segundos = 15) {
		this.cooldownSegundos = segundos
		this.ultimoCheckEmMs = Date.now()

		if (this.cooldownTimer) {
			window.clearInterval(this.cooldownTimer)
		}

		this.cooldownTimer = window.setInterval(() => {
			this.cooldownSegundos = Math.max(0, this.cooldownSegundos - 1)

			if (this.cooldownSegundos === 0 && this.cooldownTimer) {
				window.clearInterval(this.cooldownTimer)
				this.cooldownTimer = null
			}
		}, 1000)
	}

	limparCooldown() {
		this.cooldownSegundos = 0
		this.ultimoCheckEmMs = null
		if (this.cooldownTimer) {
			window.clearInterval(this.cooldownTimer)
			this.cooldownTimer = null
		}
	}

	calcularPercentualDescontoDoItem(desconto: Desconto, item: ItemDaVenda): number {
		if (!desconto || desconto.valor <= 0) return 0
		const base = item.preco || 0
		if (base <= 0) return 0

		return desconto.isPercentual ? desconto.valor : (desconto.valor / base) * 100
	}

	calcularValorBrutoDaVenda(venda: any): number {
		let valorBruto = 0

		for (const item of venda.itens) {
			if (item.possuiDescontoPorTabela) {
				const descontoTabela = item.preco * (item.desconto.valor / 100)
				valorBruto += (item.preco - descontoTabela)
			} else {
				valorBruto += item.preco
			}
		}

		return valorBruto
	}

	calcularPercentualDescontoDaCapa(desconto: Desconto, venda: any): number {
		if (!desconto || desconto.valor <= 0) return 0
		const bruto = this.calcularValorBrutoDaVenda(venda)
		if (bruto <= 0) return 0

		return desconto.isPercentual ? desconto.valor : (desconto.valor / bruto) * 100
	}

	cancelarDescricaoRemota() {
		this.mostraModalDescricaoRemoto = false
		this.descricaoRemota = ''
	}

	fecharDescricaoRemotaPeloUsuario() {
		this.cancelarDescricaoRemota()
		this.mostra = false
	}

}
